import { useHubCatalog } from '../../hooks/useHubCatalog';
import { ownsVolume } from '../../lib/hub-api';
import { VolumeCard } from '../../components/VolumeCard';

export function RebuildsPage() {
  const { volumes, entitlements, loading, error } = useHubCatalog();
  if (loading) return <div className="page-loading"><span className="loader" />Loading the Rebuild Series…</div>;
  return (
    <div className="hub-page">
      <header className="page-header"><p className="eyebrow">The Rebuild Series</p><h1>One Hub. Four Rebuilds.</h1><p>The platform stays the same. Each purchase unlocks the corresponding rebuild system inside your account.</p></header>
      {error && <div className="error-banner">{error}</div>}
      <div className="volume-grid">{volumes.map((volume) => <VolumeCard key={volume.id} volume={volume} owned={ownsVolume(entitlements, volume.id)} />)}</div>
      <section className="card entitlement-explainer">
        <p className="eyebrow">How access works</p><h2>One account. Volume-specific entitlements.</h2>
        <p>Buying Clarity unlocks Clarity’s course, ebook, audiobook, workbook, anchors, Blueprint, Rebuild Map, Delphi context, coaching, and related resources. Buying another volume expands this same account without replacing what you already own.</p>
      </section>
    </div>
  );
}
